import React from 'react';
import { useT, useIsMobile } from '@repo/common';

import { ReactComponent as PlusIcon } from '@repo/common/assets/icons/24px/icon_24px_plus.svg';
import { ReactComponent as ManualBookIcon } from '@repo/common/assets/icons/24px/icon_24px_manual-book_outline.svg';
import { ReactComponent as FolderIcon } from '@repo/common/assets/icons/24px/icon_24px_folder_outline.svg';

const config = {
  guide: {
    icon: ManualBookIcon,
    iconBg: 'text-icon-placeholder',
  },
  manage: {
    icon: FolderIcon,
    iconBg: 'text-beige-beige05',
  },
};

const CareerHeaderButton = ({ type, text, onClick }) => {
  const t = useT();
  const isMobile = useIsMobile();

  if (type === 'create') {
    return (
      <div
        onClick={onClick}
        className='flex flex-col justify-center items-center gap-3 p-4 pr-6 h-[180px] tabletH:h-[200px] w-full rounded-[15px] bg-grayscale-gray00 cursor-pointer transition-all duration-200 active:scale-[0.97]'
        style={{
          backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='15' ry='15' stroke='%23009E4F' stroke-opacity='0.4' stroke-width='2' stroke-dasharray='6 6' stroke-linecap='round'/%3e%3c/svg%3e")`,
        }}
      >
        <div className='flex justify-center items-center gap-2.5 p-2 rounded-lg bg-surface-green10'>
          <PlusIcon className='text-green-deep04' />
        </div>
        <span className='typo-b14Strong text-green-deep04'>
          {isMobile
            ? t('Create New Resume', '이력서 새로 만들기')
            : t('Create New', '이력서 새로 만들기')}
        </span>
      </div>
    );
  }

  const { icon: Icon, iconBg } = config[type];

  return (
    <div
      onClick={onClick}
      className={`bg-grayscale-gray00 flex tabletH:flex-col items-center tabletH:justify-center w-full gap-2
                   py-3 px-4 tabletH:p-6 rounded-[15px] cursor-pointer transition-all duration-200 active:scale-[0.97]`}
    >
      <div
        className={`flex justify-center items-center size-[26px] tabletH:size-8 rounded-[5px] ${iconBg} bg-grayscale-gray01`}
      >
        <Icon />
      </div>
      <div
        className={`typo-b12Strong tabletH:typo-b18Strong text-text-secondary`}
      >
        {text}
      </div>
    </div>
  );
};

export default CareerHeaderButton;
